import { render } from "./IDDetails1.vue?vue&type=template&id=206ec614&scoped=true&ts=true"
import script from "./IDDetails1.vue?vue&type=script&lang=ts"
export * from "./IDDetails1.vue?vue&type=script&lang=ts"

import "./IDDetails1.vue?vue&type=style&index=0&id=206ec614&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206ec614"],['__file',"src/components/kyc/IDDetails1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "206ec614"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('206ec614', __exports__)) {
    api.reload('206ec614', __exports__)
  }
  
  module.hot.accept("./IDDetails1.vue?vue&type=template&id=206ec614&scoped=true&ts=true", () => {
    api.rerender('206ec614', render)
  })

}


export default __exports__